import { useEffect, useState } from 'react';
import { useWindowDimensions } from 'festo-react-ui-kit/lib/utils/utils';

import Gauge from './Gauge';
import CriticalDisplay from '../Filters/ResultsDisplay/CriticalDisplay/CriticalDisplay';

import { useAppSelector } from '../../app/hooks';
import { useNormalizeAssetPath } from '../../features/base/hooks/useBase';
import { getHighlightedValue, getValueWithTwoDecimals } from './utils';
import { FilterValueKey } from '../../features/filter/utils';
import useTranslation from '../../features/translation/hooks/useTranslation';
import useURLParams from './hooks/useURLParams';
import useFetchSolution from './hooks/useFetchSolution';
import './Solutions.scss';

enum TranslationKeys {
  MILIMETERS = 'filterUnitMillimeter',
  L_MIN = 'filterUnitLitrePerMin',
}

const Solutions = (): JSX.Element => {
  const values = useAppSelector((state) => state.filter.filtersValue);
  const { width } = useWindowDimensions();
  const t = useTranslation();
  const [isHighlighted, setisHighlighted] = useState<boolean>(false);
  const normalizeAssetPath = useNormalizeAssetPath();
  const isLowerThan1024px = width < 1024;
  const direction = isLowerThan1024px ? 'vertical' : 'horizontal';
  useURLParams(); //TODO: Think about to put on another place, maybe causes some issues here
  useFetchSolution();

  useEffect(() => {
    setisHighlighted(getHighlightedValue({ value: values.calculationResult.toString(), calculationValue: 'QN' }));
  }, [values.calculationResult]);

  return (
    <div className="result-container">
      <div className="result-container__gauges">
        <Gauge
          value={getValueWithTwoDecimals({ value: Number(values[FilterValueKey.SUPPLY_PRESSURE]) })}
          isFirstGauge
        />
        <Gauge value={getValueWithTwoDecimals({ value: Number(values[FilterValueKey.OUTPUT_PRESSURE]) })} />
      </div>
      <span className="gauge__connection--tubin-length">
        {values[FilterValueKey.TUBING_LENGTH]} {t(TranslationKeys.MILIMETERS)} (l)
      </span>
      <img
        className="gauge__connection--horizontal-arrow"
        src={normalizeAssetPath(`assets/${direction}-arrow.svg`)}
        alt="arrow flowrate"
      />
      <img
        className="gauge__connection--big-tube"
        src={normalizeAssetPath(`assets/${direction}-tube.svg`)}
        alt="tube flowrate"
      />
      <span className="gauge__connection--internal-diameter">
        {values[FilterValueKey.INTERNAL_DIAMETER]} {t(TranslationKeys.MILIMETERS)} (d)
      </span>
      <span className={`gauge__connection--normal-flowrate ${isHighlighted ? 'pd-0' : ''}`}>
        <span className={isHighlighted ? 'highlight-value' : ''}>
          {' '}
          {getValueWithTwoDecimals({ value: Number(values[FilterValueKey.DISCHARGE]) })}
        </span>{' '}
        {t(TranslationKeys.L_MIN)} (Qₙ)
        <div className="critical-container-result">
          <CriticalDisplay />
        </div>
      </span>
    </div>
  );
};

export default Solutions;
